<template>
  <div class="upload-container">
    <!-- :style="{background: color,borderColor: color}" -->
    <el-button
      icon="el-icon-upload"
      size="mini"
      type="secondary"
      @click="dialogVisible=true"
    >
      上传
    </el-button>
    <el-dialog
      :visible.sync="dialogVisible"
      :append-to-body="true"
    >
      <el-upload
        :data="form"
        :multiple="true"
        :file-list="fileList"
        :show-file-list="true"
        :on-remove="handleRemove"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        class="editor-slide-upload"
        :action="action"
        list-type="picture-card"
      >
        <!-- <el-button
          size="small"
          type="primary"
        >
          点击上传
        </el-button> -->
        <i class="el-icon-plus" />
      </el-upload>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="lightgrey"
          @click="dialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          type="secondary"
          @click="handleSubmit"
        >
          确定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import { getToken } from 'api/qiniu'
import { makeKey } from '@/utils/qiniu';
import { getQiniuToken } from '@/api/third';
import { Qiniu } from '@/types/qiniu';

export default {
  name: 'EditorSlideUpload',
  props: {
    color: {
      type: String,
      default: '#1890ff'
    }
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      qiniu: {},
      action: 'https://up-z1.qiniup.com',
      form: {}
    };
  },
  created() {
    const params = {
      type: Qiniu.UPLOAD_TYPE_OTHER
    };
    getQiniuToken(params).then(res => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
  },
  methods: {
    handleSubmit() {
      const arr = Object.keys(this.fileList).map(v => this.fileList[v]);
      // if (!arr) {
      //   this.$message('请选择图片！');
      //   return;
      // }
      this.$emit('successCBK', arr);
      this.fileList = [];
      this.dialogVisible = false;
    },
    handleSuccess(response) {
      const imgUrl = this.qiniu.default_url + response.key;
      let obj = {
        name: response.key,
        url: imgUrl
      };
      this.fileList.push(obj);
    },
    handleRemove(file) {
      for (let i = 0, len = this.fileList.length; i < len; i++) {
        if (this.fileList[i].name === file.name) {
          // delete this.fileList[i];
          this.fileList.splice(i, 1);
          return;
        }
      }
    },
    beforeUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        return this.$message.error('上传文件只能是  JPG或PNG 格式!');
      }
      if (!isLt2M) {
        return this.$message.error('上传图片大小不能超过 5MB!');
      }
      return new Promise((resolve, reject) => {
        resolve(true);
      }).then(res => {
        let k = makeKey(this.qiniu.prekey);
        this.form = {
          key: k,
          token: this.qiniu.uptoken,
          domain: this.qiniu.domain
        };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.editor-slide-upload {
  margin-bottom: 20px;
  ::v-deep .el-upload--picture-card {
    width: 100%;
  }
}
</style>
